import {Button} from "primereact/button";
import type {ReactNode} from "react";
import {useTranslation} from "react-i18next";

import {useNavigateWithQuery} from "../hooks/navigationHooks";

interface MissingDataIndicatorProps {
    /** flag if enough data is available to show the children */
    dataAvailable: boolean;
    children: ReactNode;
}

/**
 * Indicator, that not enough data is available.
 */
function MissingDataIndicator({dataAvailable, children}: MissingDataIndicatorProps): ReactNode {
    const {t} = useTranslation();

    const navigate = useNavigateWithQuery();

    if (dataAvailable) {
        return children; // Don't show error
    }

    const onNavigateToObjectInputs = () => {
        navigate("/object");
    };

    return (
        <div className="grow flex flex-col justify-center items-center">
            <div className="p-inline-message p-component p-inline-message-warn block">
                <div className="m-4 mb-8 text-2xl">
                    <span className="pi pi-lock text-2xl mr-4"></span>
                    {t("general.missingDataTitle")}
                </div>
                <p className="m-4 mt-0">{t("general.missingDataContent")}</p>
                <p className="m-4 mt-8">
                    <Button
                        label={t("object.objectParameters")}
                        severity="secondary"
                        onClick={onNavigateToObjectInputs}
                    />
                </p>
            </div>
        </div>
    );
}

export default MissingDataIndicator;
